import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { SHARE_WISHLIST_POPUP_ID } from 'Component/ShareWishlistPopup/ShareWishlistPopup.config';
import MyAccountQuery from 'Query/MyAccount.query';
import { CHECKOUT_URL, DETAILS_URL_STEP } from 'Route/Checkout/Checkout.config';
import { ACCOUNT_LOGIN_URL, ACCOUNT_MENU_URL } from 'Route/MyAccount/MyAccount.config';
import {
    DEFAULT_HEADER_STATE,
    HeaderContainer as SourceHeaderContainer,
    mapStateToProps
} from 'SourceComponent/Header/Header.container';
import { changeNavigationState, goToPreviousNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { hideActiveOverlay, toggleOverlayByKey } from 'Store/Overlay/Overlay.action';
import { showPopup } from 'Store/Popup/Popup.action';
import { MY_ACCOUNT } from 'Type/Account.type';
import { isSignedIn } from 'Util/Auth';
import BrowserDatabase from 'Util/BrowserDatabase/BrowserDatabase';
import history from 'Util/History';
import { prepareQuery } from 'Util/Query';
import { executePost } from 'Util/Request';
import { appendWithStoreCode } from 'Util/Url';

import {
    CART_OVERLAY,
    MENU,
    SEARCH
} from './Header.config';

export {
    mapStateToProps,
    DEFAULT_HEADER_STATE
};
export const MyAccountDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/MyAccount/MyAccount.dispatcher'
);

/** @namespace Elganso/Component/Header/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showOverlay: (overlayKey) => dispatch(toggleOverlayByKey(overlayKey)),
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    setNavigationState: (stateName) => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName)),
    showPopup: (payload) => dispatch(showPopup(SHARE_WISHLIST_POPUP_ID, payload)),
    goToPreviousNavigationState: () => dispatch(goToPreviousNavigationState(TOP_NAVIGATION_TYPE)),
    signIn: (options) => MyAccountDispatcher.then(
        ({ default: dispatcher }) => dispatcher.signIn(options, dispatch)
    ),
    signInSocial: (token) => MyAccountDispatcher.then(
        ({ default: dispatcher }) => dispatcher.signInSocial(token, dispatch)
    )
});

/** @namespace Elganso/Component/Header/Container */
export class HeaderContainer extends SourceHeaderContainer {
    containerFunctions = {
        ...this.containerFunctions,
        onSearchButtonClick: this.onSearchButtonClick.bind(this),
        tryAutoLogin: this.tryAutoLogin.bind(this),
        showMenu: this.showMenu.bind(this),
        showMenuDesktop: this.showMenuDesktop.bind(this),
        closeMenuDesktop: this.closeMenuDesktop.bind(this),
        onSignInAccountButtonClick: this.onSignInAccountButtonClick.bind(this),
        onShareFooterOutsideClick: this.onShareFooterOutsideClick.bind(this),
        onShareFooterLink: this.onShareFooterLink.bind(this),
        onShareFooterClick: this.onShareFooterClick.bind(this)
    };

    __construct(props) {
        super.__construct(props);

        this.state = {
            ...this.state,
            showingMinicart: false,
            showingMenuDesktop: false,
            showShareFooter: false
        };
    }

    containerProps() {
        const { location } = this.props;
        const { showingMenuDesktop, showShareFooter } = this.state;

        const {
            location: {
                pathname
            }
        } = history;

        let isCheckout = false;

        if (pathname.includes(CHECKOUT_URL) && !pathname.includes(DETAILS_URL_STEP)) {
            isCheckout = pathname.includes(CHECKOUT_URL);
        }

        return {
            ...super.containerProps(),
            isCheckout,
            showingMenuDesktop,
            location,
            showShareFooter
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.tryAutoLogin();
        this.trySocialLogin();
    }

    componentDidUpdate(e) {
        const {
            showingMenuDesktop,
            prevPathname
        } = this.state;

        if (showingMenuDesktop && prevPathname !== e.location.pathname) {
            this.setState({ showingMenuDesktop: false });
        }
        this.setState({ prevPathname: e.location.pathname });
    }

    showMenu() {
        // eslint-disable-next-line no-console
    }

    showMenuDesktop() {
        this.setState({ showingMenuDesktop: true });
    }

    closeMenuDesktop() {
        this.setState({ showingMenuDesktop: false });
    }

    onShareFooterOutsideClick() {
        this.setState({ showShareFooter: false });
    }

    onShareFooterClick() {
        this.setState({ showShareFooter: !this.state.showShareFooter });
    }

    onShareFooterLink() {
        this.setState({ showShareFooter: false });

        if (window.navigator.share) {
            window.navigator.share({
                title: 'El Ganso',
                text: window.document.title,
                url: window.location.href
            }).then(
                /** @namespace Elganso/Component/Header/Container/HeaderContainer/onShareFooterLink/then/catch/share/then */
                // eslint-disable-next-line no-console
                () => console.log('Successful share')
            ).catch(
                /** @namespace Elganso/Component/Header/Container/HeaderContainer/onShareFooterLink/then/catch */
                // eslint-disable-next-line no-console
                (error) => console.log('Error sharing', error)
            );
        } else {
            alert('Tu navegador no soporta esta funcion.');
        }
    }

    onSearchBarFocus() {
        const {
            setNavigationState,
            goToPreviousNavigationState,
            showOverlay,
            navigationState: { name },
            device
        } = this.props;

        if (
            (!device.isMobile && name === SEARCH)
            || (device.isMobile && (name !== MENU))
        ) {
            return;
        }

        showOverlay(SEARCH);

        setNavigationState({
            name: SEARCH,
            onBackClick: () => {
                showOverlay(MENU);
                goToPreviousNavigationState();
            }
        });
    }

    onSearchButtonClick() {
        history.push(appendWithStoreCode('/searchtab'));
        this.lastSeenMenu = 0;
    }

    onBackButtonClick(e) {
        const { navigationState: { onBackClick, name = '' }, location: { pathname = '' } } = this.props;

        this.setState({ searchCriteria: '' });

        if (name === MY_ACCOUNT && pathname.includes(ACCOUNT_MENU_URL)) {
            history.push(appendWithStoreCode('/'));
        } else if (onBackClick) {
            onBackClick(e);
        }
    }

    onMinicartButtonClick() {
        const {
            showOverlay,
            navigationState: { name },
            hideActiveOverlay,
            goToPreviousNavigationState
        } = this.props;

        if (name === CART_OVERLAY) {
            goToPreviousNavigationState();
            hideActiveOverlay();
            return;
        }

        this.setState({ shouldRenderCartOverlay: true });

        showOverlay(CART_OVERLAY);
    }

    onMinicartOutsideClick() {
        const {
            goToPreviousNavigationState,
            hideActiveOverlay,
            navigationState: { name }
        } = this.props;

        if (name !== CART_OVERLAY) {
            return;
        }

        goToPreviousNavigationState();
        hideActiveOverlay();
    }

    tryAutoLogin() {
        const {
            signIn
        } = this.props;
        const token = BrowserDatabase.getItem('user_login');

        if (!isSignedIn() && token !== null && token !== '') {
            const query = MyAccountQuery.autoLogin(token);
            executePost(prepareQuery([query])).then(
                /** @namespace Elganso/Component/Header/Container/HeaderContainer/tryAutoLogin/executePost/then */
                ({ autoLogin }) => {
                    const user = JSON.parse(autoLogin);
                    signIn(user);
                }
            );
        }
    }

    trySocialLogin() {
        const {
            signInSocial
        } = this.props;
        const tokenGenerado = localStorage.getItem('tokenGenerado');

        if (!isSignedIn() && tokenGenerado !== null && tokenGenerado !== '') {
            signInSocial(tokenGenerado);
        }
    }

    onSignInAccountButtonClick() {
        if (isSignedIn()) {
            history.push({ pathname: appendWithStoreCode(ACCOUNT_MENU_URL) });
        } else {
            sessionStorage.setItem('redirectAfterLogin', location.pathname);
            history.push({ pathname: appendWithStoreCode(ACCOUNT_LOGIN_URL) });
        }
    }

    onMyAccountButtonClick() {
        if (!isSignedIn()) {
            sessionStorage.setItem('redirectAfterLogin', location.pathname);
        }

        super.onMyAccountButtonClick();
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderContainer));
